import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UserSelectionsService } from '../../services/user-selections/user-selections.service';
import { Router } from '@angular/router';
import { OptionCardSelected } from '../../types/strings.type';
import { StringsService } from '../../services/strings/strings.service';
import { ErrorService } from '../../services/errors/error.service';

@Component({
    selector: 'rttd-option-card-selected',
    templateUrl: './option-card-selected.component.html',
    styles: [
        require('./option-card-selected.component.scss').default.toString(),
        require(`./option-card-selected.component.${environment.brand}.scss`).default.toString()
    ]
})
export class OptionCardSelectedComponent implements OnInit {
    content: OptionCardSelected;

    @Input() step: number;
    @Input() showModelChange = true;
    @Input() showAppointmentChange = true;
    @Input() title: string;
    timezone = environment.timezone;

    constructor(
        public userSelectionsService: UserSelectionsService,
        private router: Router,
        private stringsService: StringsService,
        private errorService: ErrorService) {
    }

    ngOnInit() {
        this.stringsService.get().subscribe((data: OptionCardSelected) => {
            this.content = data['OptionCardSelected'];
            if (!this.title) {
                this.title = data.title;
            }
        });
    }

    changeProduct() {
        this.userSelectionsService.remove('product');
        this.userSelectionsService.remove('startTime');
        this.userSelectionsService.remove('endTime');
        this.router.navigate(['/select-model'], {skipLocationChange: true});
    }

    changeAppointment() {
        this.router.navigate(['/select-appointment'], {skipLocationChange: true});
    }
}

